import TransferItem from './../models/transfer-item';

import * as TransferItemsHelper from '@app/helper/transfer-items';

export function normalizeTransfer(transfer) {
  let newTransfer = { ...transfer };

  // Ensure consistent usage of expiresAt and expiryInSeconds naming
  if (
    typeof newTransfer.expires_at === 'string' ||
    typeof newTransfer.expires_at === 'object'
  ) {
    newTransfer = { expiresAt: transfer.expires_at, ...transfer };
    delete newTransfer.expires_at;
  }

  if (typeof newTransfer.expiry_in_seconds === 'number') {
    newTransfer = {
      expiryInSeconds: transfer.expiry_in_seconds,
      ...newTransfer,
    };
    delete newTransfer.expiry_in_seconds;
  }

  newTransfer.description = newTransfer.description || newTransfer.message;

  const files = newTransfer.files || newTransfer.items || []; // Let's save the files array

  let sizeFromFiles = 0;

  if (
    newTransfer.state === 'init' ||
    (newTransfer.files && !newTransfer.items)
  ) {
    newTransfer.items = files.map((file) => {
      file.apiType = file.apiType || file.item_type;

      sizeFromFiles += file.size;

      return {
        id: file.id,
        content_identifier: 'file',
        name: file.name,
        size: file.size,
        downloadable: true,
        previewable: file.previewable,
        apiType: file.apiType,
        file: new TransferItem(file),
      };
    });
  }

  newTransfer.size = transfer.size || sizeFromFiles;

  newTransfer.items = TransferItemsHelper.getItemsWithUITypes(
    newTransfer.items
  );
  newTransfer.itemsTree = TransferItemsHelper.buildItemsTree(newTransfer.items);
  newTransfer.files = files;

  newTransfer.title = newTransfer.display_name;
  /*
   * items (and files) can be empty when this function is called from the
   * Files#render (components/transfer/uploader/files.js)
   * this is also the case if the transfer is password protected
   * */
  if (!newTransfer.title && newTransfer.items.length) {
    newTransfer.title = TransferItemsHelper.getSubNodesFromItemName(
      newTransfer.items[0].name
    ).pop();
  }

  return newTransfer;
}
